import React, { useCallback, useState, useEffect } from "react";
import { Row, Col, Select, Form, Checkbox } from "antd";
import { useIntl } from "react-intl";

import Service from "./service";

const { Item } = Form;
const { Option } = Select;

function DomesticServices({
  onCashTransportPay,
  initialServices,
  invoiceAddress,
  disabled,
  mainForm,
  product,
  rules,
}) {
  const intl = useIntl();
  const { getFieldDecorator } = mainForm;

  const [showInvoice, setShowInvoice] = useState();
  useEffect(() => {
    setShowInvoice(invoiceAddress ? true : false);
  }, [invoiceAddress]);

  const handleCashTransportPayChange = useCallback(
    (e) => {
      !e.target.checked && onCashTransportPay(showInvoice);
    },
    [onCashTransportPay, showInvoice]
  );
  const handleInvoiceAddressChange = useCallback(
    (e) => {
      onCashTransportPay(e.target.checked);
    },
    [onCashTransportPay]
  );

  return (
    <>
      {rules.documentBack && (
        <Service
          disabled={disabled}
          label={intl.formatMessage({
            id: "consignment.services.documentBack",
            defaultMessage: "Dokumenty zpět",
          })}
          fieldName="documentBack"
          getFieldDecorator={getFieldDecorator}
          initialValue={initialServices && initialServices.documentBack}
        />
      )}
      {(product.code === "ECD_B2C"
        ? rules.smsPrivatePallet
        : rules.smsCompanyPallet) && (
        <Service
          label={intl.formatMessage({
            id: "consignment.services.sms",
            defaultMessage: "SMS",
          })}
          fieldName="sms"
          disabled={disabled}
          getFieldDecorator={getFieldDecorator}
          initialValue={initialServices ? initialServices.sms : true}
        />
      )}
      {rules.cashTransport && (
        <Row type="flex" align="middle">
          <Service
            disabled={disabled}
            fieldName="cashTransportPay"
            label={intl.formatMessage({
              id: "consignment.services.cashTransportPay",
              defaultMessage: "Platba za přepravné hotově",
            })}
            getFieldDecorator={getFieldDecorator}
            onChange={handleCashTransportPayChange}
            initialValue={
              initialServices && initialServices.cashTransportPayer > 0
            }
          />
          <Col span={16}>
            {mainForm.getFieldValue("cashTransportPay") && (
              <div>
                <Item
                  label={intl.formatMessage({
                    id: "consignment.services.payer",
                    defaultMessage: "Plátce",
                  })}
                  wrapperCol={{ span: 9 }}
                >
                  {getFieldDecorator("cashTransportPayer", {
                    ...(initialServices && {
                      initialValue: initialServices.cashTransportPayer,
                    }),
                    rules: [
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "consignment.services.emptyPayer",
                          defaultMessage: "Vyberte prosím plátce!",
                        }),
                      },
                    ],
                  })(
                    <Select allowClear disabled={disabled}>
                      <Option key={1} value={1}>
                        {intl.formatMessage({
                          id: "consignment.services.consignee",
                          defaultMessage: "Příjemce",
                        })}
                      </Option>
                      <Option key={2} value={2}>
                        {intl.formatMessage({
                          id: "consignment.services.consignor",
                          defaultMessage: "Odesílatel",
                        })}
                      </Option>
                    </Select>
                  )}
                </Item>
                {mainForm.getFieldValue("cashTransportPayer") && (
                  <Item wrapperCol={{ offset: 5 }}>
                    {getFieldDecorator("invoiceAddress", {
                      initialValue: showInvoice,
                      valuePropName: "checked",
                    })(
                      <Checkbox
                        disabled={disabled}
                        onChange={handleInvoiceAddressChange}
                      >
                        {intl.formatMessage({
                          id: "consignment.services.otherAddress",
                          defaultMessage: "Jiná fakturační adresa",
                        })}
                      </Checkbox>
                    )}
                  </Item>
                )}
              </div>
            )}
          </Col>
        </Row>
      )}
    </>
  );
}

export default DomesticServices;
